import { ADD_CLUSTER,GET_ALL_CLUSTER,ADD_CLINIC, GET_ALL_CLINIC,ADD_PRACTITIONER, GET_ALL_PRACTITIONER,GET_PRACTITIONER_BY_ID, MODIFY_STATUS_CLUSTER, MODIFY_STATUS_CLINIC, MODIFY_STATUS_PRACTITIONER, GET_CLUSTER_BY_ID, UPDATE_CLUSTER_BY_ID, GET_CLINIC_BY_ID, UPDATE_CLINIC_BY_ID, UPDATE_PRACTITIONER_BY_ID, GET_ROLES, SET_ROLES} from "../types";
import { call, takeLatest } from "redux-saga/effects";
import { AddClusterApi, GetAllClusterApi,AddClinicApi, GetAllClinicApi, AddPractitionerApi,GetAllPractitionerByIdApi, GetAllPractitionerApi, modifyClusterStatusApi, modifyClinicStatusApi, modifyPractitionerStatusApi, GetAllClusterByIdApi, UpdateClusterApi,GetAllClinicByIdApi, UpdateClinicApi, UpdatePractitionerApi, GetRolesApi, SetRolesApi } from "../api/team-managment-api";


export function* addClusterWorker(action: any): any {
  try {
    const res: any = yield call(AddClusterApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* addClinicWorker(action: any): any {
  try {
    const res: any = yield call(AddClinicApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* AddPractitionerWorker(action: any): any {
  try {
    const res: any = yield call(AddPractitionerApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* GetAllClusterWorker(action: any): any {
  try {
    const res: any = yield call(GetAllClusterApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* GetClusterByIdWorker(action: any): any {
  try {
    const res: any = yield call(GetAllClusterByIdApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* GetPractitionerByIdWorker(action: any): any {
  try {
    const res: any = yield call(GetAllPractitionerByIdApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* GetClinicByIdWorker(action: any): any {
  try {
    const res: any = yield call(GetAllClinicByIdApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* GetAllClinicWorker(action: any): any {
  try {
    const res: any = yield call(GetAllClinicApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* GetAllPractitionerWorker(action: any): any {
  try {
    const res: any = yield call(GetAllPractitionerApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* modifiyClusterStatusWorker(action: any): any {
  try {
    const res: any = yield call(modifyClusterStatusApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* modifiyClinicStatusWorker(action: any): any {
  try {
    const res: any = yield call(modifyClinicStatusApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* modifiyPractitionerStatusWorker(action: any): any {
  try {
    const res: any = yield call(modifyPractitionerStatusApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* updateClusterByIdWorker(action: any): any {
  try {
    const res: any = yield call(UpdateClusterApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* updateClinicByIdWorker(action: any): any {
  try {
    const res: any = yield call(UpdateClinicApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}

export function* updatePractitionerByIdWorker(action: any): any {
  try {
    const res: any = yield call(UpdatePractitionerApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data ?? error);
  }
}


export function* addClusterWatcher() {
  yield takeLatest(ADD_CLUSTER, addClusterWorker);
}
export function* addClinicWatcher() {
  yield takeLatest(ADD_CLINIC, addClinicWorker);
}
export function* AddPractitionerWatcher() {
  yield takeLatest(ADD_PRACTITIONER, AddPractitionerWorker);
}
export function* getAllClusterWatcher() {
  yield takeLatest(GET_ALL_CLUSTER, GetAllClusterWorker);
}
export function* getClusterByIdWatcher() {
  yield takeLatest(GET_CLUSTER_BY_ID, GetClusterByIdWorker);
}
export function* getPractitionerByIdWatcher() {
  yield takeLatest(GET_PRACTITIONER_BY_ID, GetPractitionerByIdWorker);
}
export function* getClinicByIdWatcher() {
  yield takeLatest(GET_CLINIC_BY_ID, GetClinicByIdWorker);
}
export function* getAllClinicWatcher() {
  yield takeLatest(GET_ALL_CLINIC, GetAllClinicWorker);
}
export function* getAllPractitionerWatcher() {
  yield takeLatest(GET_ALL_PRACTITIONER, GetAllPractitionerWorker);
}
export function* modifyClusterStatusWatcher() {
  yield takeLatest(MODIFY_STATUS_CLUSTER, modifiyClusterStatusWorker);
}
export function* modifyClinicStatusWatcher() {
  yield takeLatest(MODIFY_STATUS_CLINIC, modifiyClinicStatusWorker);
}
export function* modifyPractitionerStatusWatcher() {
  yield takeLatest(MODIFY_STATUS_PRACTITIONER, modifiyPractitionerStatusWorker);
}
export function* updateClusterByIdWatcher() {
  yield takeLatest(UPDATE_CLUSTER_BY_ID, updateClusterByIdWorker);
}
export function* updateClinicByIdWatcher() {
  yield takeLatest(UPDATE_CLINIC_BY_ID, updateClinicByIdWorker);
}
export function* updatePractitionerByIdWatcher() {
  yield takeLatest(UPDATE_PRACTITIONER_BY_ID, updatePractitionerByIdWorker);
}

export function* getRolesWorker(action: any): any {
  try {
    const res: any = yield call(GetRolesApi);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data || { message: "Failed to fetch roles" });
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data || error);
  }
}

export function* getRolesWatcher() {
  yield takeLatest(GET_ROLES, getRolesWorker);
}

export function* setRolesWorker(action: any): any {
  try {
    const res: any = yield call(SetRolesApi, action.data);
    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data || { message: "Failed to set role" });
    }
  } catch (error: any) {
    yield call(action.onError, error?.response?.data || error);
  }
}

export function* setRolesWatcher() {
  yield takeLatest(SET_ROLES, setRolesWorker);
}